import Vue from 'vue'
import Vuex from 'vuex'
import devOps from './devOps'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    devOps
  }
})
